module.exports = __webpack_public_path__ + "components/app-promo/static/intersport/8-6f19cd39a00ec1b62aeb9c698fcc157c.png";